import { Tooltip } from 'antd'
import { Formik } from 'formik'
import React from 'react'
import { ContainerDivProps, ContainerDiv, FjCheckBox } from 'src/components/Common'
import HTMLExpandablePreview from 'src/components/Common/HTMLExpandablePreview'
import { Colors } from 'src/constants/colors'
import minusBoxIcon from 'src/assets/icons/minusBox.svg'

interface LearningObjectPreviewCardProps {
  objectId: string
  selected?: boolean
  inProgress: boolean
  isCompleted: boolean
  cursorStyle?: string
  onClickHandler: () => void
  checkBoxClickhandler: () => void
  isPassed?: boolean
  locked: boolean
  checkboxDisabled: boolean
  imgComponent: React.ReactNode
  title: string
  style?: ContainerDivProps
}

export const LearningObjectPreviewCard: React.FC<LearningObjectPreviewCardProps> = ({
  objectId,
  selected,
  isCompleted = false,
  cursorStyle = 'normal',
  onClickHandler,
  checkBoxClickhandler = () => {},
  isPassed,
  locked,
  checkboxDisabled,
  imgComponent,
  title,
  style,
}) => {
  return (
    <ContainerDiv
      borderBottom={`solid 1px ${Colors.sharkOpacity10}`}
      borderLeft={selected ? `solid 6px ${Colors.texasRose}` : undefined}
      padding="10px 18px 18px 18px"
      display="flex"
      backgroundColor={Colors.white}
      cursor={cursorStyle}
      onClick={onClickHandler}
      {...style}
      gap={16}
    >
      {isPassed === false ? (
        <Tooltip title="Not Passed">
          <img src={minusBoxIcon} alt="Not Passed" height={18} width={18} />
        </Tooltip>
      ) : (
        <Formik initialValues={{}} onSubmit={() => {}}>
          <FjCheckBox
            name="content-complete-check"
            size="large"
            value={objectId}
            onChange={checkBoxClickhandler}
            checked={isCompleted}
            disabled={checkboxDisabled || locked}
          />
        </Formik>
      )}
      <ContainerDiv textAlign="left" display="flex" flexDirection="column" alignItems="start" gap="10px">
        {imgComponent}
        <ContainerDiv
          textAlign="left"
          overflowWrap="anywhere"
          color={locked ? Colors.cottonSeed : Colors.black}
          className="no-margin"
        >
          <HTMLExpandablePreview
            rows={2}
            html={title}
            expandable={false}
            parserOptions={{ showEmbedAsLink: true, showMediaAsLink: true, minimizeHeadings: true }}
          />
        </ContainerDiv>
      </ContainerDiv>
    </ContainerDiv>
  )
}
